import React from 'react'
import { GiMeeple } from 'react-icons/gi'
import { BsClock } from 'react-icons/bs'
import { Box, Image, Text, Icon, Heading, Link, VStack, Flex, useColorModeValue } from '@chakra-ui/react'
import { getBggGameCoverUrl } from '../Utils'

export default function ChosenGame(props) {
	const game = {
		name: props.game.name['#text'],
		minPlayers: props.game.stats['@_minplayers'],
		maxPlayers: props.game.stats['@_maxplayers'],
		bggRating: props.game.stats.rating.average['@_value'],
		id: props.game['@_objectid'],
	}

	const border = useColorModeValue('gray.200', 'whiteAlpha.300')
	const bg = useColorModeValue('white', 'bgg.800')
	const titleHoverColor = useColorModeValue('brand.600', 'brand.300')
	const metaMuted = useColorModeValue('gray.600', 'bgg.muted')
	const coverLayout = props.coverLayout === 'intrinsic' ? 'intrinsic' : 'card'

	const formatPlayerCount = (min, max) => {
		if (min === max) return min
		return `${min}–${max}`
	}

	const containerMaxW = props.maxW != null ? props.maxW : 'sm'

	return (
		<Box
			maxW={containerMaxW}
			w="full"
			overflow="hidden"
			rounded="2xl"
			borderWidth="1px"
			borderColor={border}
			bg={bg}
			boxShadow="md"
		>
			{coverLayout === 'intrinsic' ? (
				<Box w="full" minH="200px" bg="gray.100" lineHeight={0} textAlign="center">
					<Image
						src={getBggGameCoverUrl(props.game)}
						alt=""
						w="full"
						maxW="100%"
						h="auto"
						maxH="min(70vh, 640px)"
						objectFit="contain"
						display="inline-block"
						verticalAlign="top"
						bg="gray.100"
					/>
				</Box>
			) : (
				<Image src={getBggGameCoverUrl(props.game)} alt="" objectFit="cover" w="full" h="240px" bg="gray.100" />
			)}
			<Box p={6}>
				<Heading size="md" color="gray.800" mb={4} lineHeight="short" _dark={{ color: 'gray.100' }}>
					<Link
						href={`https://boardgamegeek.com/boardgame/${game.id}`}
						isExternal
						color="inherit"
						_hover={{ color: titleHoverColor, textDecoration: 'none' }}
					>
						{game.name}
					</Link>
				</Heading>
				<VStack align="stretch" spacing={2} fontSize="sm" color={metaMuted}>
					<Flex align="center" gap={2}>
						<Icon as={GiMeeple} color="brand.500" />
						<Text>{formatPlayerCount(game.minPlayers, game.maxPlayers)} players</Text>
					</Flex>
					<Flex align="center" gap={2}>
						<Icon as={BsClock} color="brand.500" />
						<Text>{props.game.stats['@_playingtime']} min</Text>
					</Flex>
					<Text pt={2}>
						<Text as="span" fontWeight="600" color="brand.600" _dark={{ color: 'brand.300' }}>
							BGG rating
						</Text>{' '}
						{game.bggRating}
					</Text>
				</VStack>
			</Box>
		</Box>
	)
}
